import { createReducer } from '@reduxjs/toolkit';

import { hideLoadingSpinner, notFoundError, notFoundErrorReset, showLoadingSpinner } from './feedback-actions';

export interface FeedbackState {
    loading: boolean;
    notFoundError: boolean;
}

const initialState: FeedbackState = {
    loading: false,
    notFoundError: false,
};

export const feedbackReducer = createReducer(initialState, builder => {
    builder.addCase(showLoadingSpinner, state => ({ ...state, loading: true }));
    builder.addCase(hideLoadingSpinner, state => ({ ...state, loading: false }));
    builder.addCase(notFoundError, state => ({ ...state, notFoundError: true }));
    builder.addCase(notFoundErrorReset, state => ({ ...state, notFoundError: false }));
});
